function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const Planet = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 25 25",
  fill: "none"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.5 24.4717C19.4036 24.4717 25 18.9936 25 12.2359C25 5.47819 19.4036 0 12.5 0C5.59644 0 0 5.47819 0 12.2359C0 18.9936 5.59644 24.4717 12.5 24.4717Z",
  fill: "#009ADF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.6962 5.15642C22.1419 5.07117 16.4633 4.26577 15.4664 7.19392C14.4198 10.2667 11.7845 9.7547 12.6843 12.9296C13.5841 16.1046 16.0943 17.9485 19.2333 17.5388C22.8411 17.0678 15.9384 22.3099 18.6632 22.884C24.682 19.654 27.1542 11.568 22.6962 5.15642Z",
  fill: "#8AC149"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.68686 1.9758C5.68686 1.9758 12.2551 1.38424 12.4813 3.32943C12.7074 5.27462 11.6907 4.92703 9.88159 6.04893C8.07244 7.17083 5.79367 6.5821 4.76929 8.28755C3.7449 9.99301 0.407593 9.12545 0.407593 9.12545C0.407593 9.12545 1.1149 4.88888 5.68686 1.9758Z",
  fill: "#8AC149"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0.258362 14.4886C0.258362 14.4886 4.27026 13.6465 5.73538 16.4117C7.20051 19.1773 8.35144 18.0503 9.29306 19.2795C9.5577 19.6252 9.53316 20.0807 9.36042 20.5569C8.69691 22.3876 6.4143 23.0804 4.7798 21.9793C3.12895 20.8668 1.17352 18.6969 0.258362 14.4886Z",
  fill: "#8AC149"
}));

Planet.defaultProps = {
  width: 25,
  height: 25
};
export default Planet;